module.exports = {"231222001":"颜河街道","231222002":"顺达街道","231222003":"兰亚街道","231222004":"正阳街道","231222101":"兰西镇","231222102":"榆林镇","231222103":"临江镇","231222104":"平山镇","231222105":"红光镇","231222106":"远大镇","231222200":"康荣乡","231222201":"燎原乡","231222202":"北安乡","231222203":"长江乡","231222204":"兰河乡","231222205":"红星乡","231222207":"长岗乡","231222210":"星火乡","231222211":"奋斗乡","231222580":"第一原种场","231222581":"第二原种场","231222582":"肉用种羊场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231222.json
// module id = 734
// module chunks = 0